import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';


export default function Corporatebankopening() {

    const posts = [
        {
            title: "Mainland Company Setup",
            desc: "Explore limitless possibilities with Speed Type expert guidance in Mainland company formation in Dubai.",
        },
        {
            title: "Offshore Company Setup",
            desc: "Offshore companies can be created and owned by individuals or institutions, and shares can be easily and freely transferred by a written instrument.",
        },
        {
            title: "Free Zone Company Setup",
            desc: "Explore boundless opportunities with A&A Associate LLC’s Freezone company formation in Dubai, UAE !",
        },
    ]


    return (
        <>
            <div className=" main-corporate-bg-img" style={{ zIndex: -99 }}>
                <section className="py-28 relative " >
                    <div className="relative z-10 max-w-screen-xl mx-auto px-4 md:text-center md:px-8">
                        <div className="max-w-xl md:mx-auto">
                            <ScrollAnimation animateIn="fadeIn">
                                <p className="text-white text-3xl font-bold sm:text-4xl">
                                    Corporate <span style={{ color: "#eab308" }}>Bank Opening</span>
                                </p>
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn">
                                <p className="text-blue-100 mt-3">
                                    If you open a company in Dubai, then you will most likley need a company account. This is called a Corporate Bank Account in Dubai:
                                </p>
                            </ScrollAnimation>

                        </div>
                        <div className="mt-4">
                            <a href="javascript:void(0)" className="inline-block py-2 px-4 text-gray-800 font-medium bg-white duration-150 hover:bg-gray-100 active:bg-gray-200 rounded-full">
                                Get A Free Quote
                            </a>
                        </div>
                    </div>
                </section>
            </div>

            <div style={{ backgroundColor: "#f2f9ff", paddingTop: 40, paddingBottom: 40 }}>
                <section className="py-2 mt-5">
                    <div className="max-w-screen-xl mx-auto px-4  gap-x-12 justify-between md:flex md:px-8">
                        <div className="max-w-xxl">
                            <ScrollAnimation animateIn="fadeIn">
                                <h3 className="text-gray-600 text-3xl font-bold sm:text-3xl pb-1">
                                    Opening Company <span style={{ color: "#eab308" }}>Bank Account In Dubai</span>
                                </h3>
                            </ScrollAnimation>

                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                The United Arab Emirates (UAE) is known for its financial industry and the elevated level of security the banks give their customers. The development of privately owned businesses and Zero percent tax rate has transformed formed the monetary scene of the UAE. It offers a proficient financial framework for organizations to work and contribute to the monetary development of the nation.
                            </p>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                The nation has attracted many business owners to invest in the land of Dubai, UAE. This has led to open bank accounts for corporate. These companies manage their entire financial transactions through a corporate bank account. However, the banks also welcome individuals to open and maintain an account. Opening a company bank account in Dubai for business has a particular procedure to follow.
                            </p>
                        </div>
                    </div>
                </section>
            </div>


            <div className='bg-img-step-corporate' style={{ backgroundColor: "#f2f9ff", paddingTop: 40, paddingBottom: 40 }}>
                <section className="py-14">
                    <div className="max-w-screen-xl mx-auto md:px-8">
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInLeft">
                                    <img src="https://wise.com/imaginary-v2/b9df01fd87577a4cce6e1246b561a260.jpg?width=600" className="md:max-w-lg sm:rounded-lg" alt="" />
                                </ScrollAnimation>
                            </div>
                            <div className="max-w-xxl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xxl">
                                <ScrollAnimation animateIn="fadeInRight">
                                    <p className="text-gray-800 text-3xl font-bold sm:text-3xl">
                                        Steps To Open a Corporate Business <span style={{ color: "#eab308" }}>Bank Account In Dubai</span>
                                    </p>
                                    <p className="mt-3 text-gray-600">
                                        If you own any business or a registered branch or subsidiary company, you need to have an active business account. Opening a business bank account in Dubai is available for Free zone companies and offshore companies. The requirement to open a bank account varies from bank to bank. Here are the steps you must follow while opening a business bank account in the UAE.
                                    </p>
                                    <p className="text-gray-800 text-3xl font-semibold sm:text-2xl">
                                        Fill an <span style={{ color: "#eab308", fontWeight: 700 }}>Account Opening Form</span>
                                    </p>
                                    <p className="mt-3 text-gray-600">
                                        The banks will provide you an account application form which is supported by several documents. You need to attach various documents that prove the existence of the business.
                                    </p>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


            <div style={{ paddingTop: 40, paddingBottom: 40 }}>
                <section className="py-2 mt-5">
                    <div className="max-w-screen-xl mx-auto px-4  gap-x-12 justify-between md:flex md:px-8">
                        <div className="max-w-xxl">
                            <ScrollAnimation animateIn="fadeIn">
                                <h3 className="text-gray-600 text-3xl font-bold sm:text-3xl pb-1">
                                    Requirements <span style={{ color: "#eab308", fontWeight: 700 }}>(Documents to be attached)</span>
                                </h3>
                            </ScrollAnimation>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" id="IconChangeColor" height="18" width="18">
                                    <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" id="mainIconPathAttribute" fill="#FFD700"></path>
                                </svg>
                                <p className="ml-3 text-gray-800 font-medium" style={{ lineHeight: 2 }}>
                                    The passport and residence visa of the company’s shareholders and directors
                                </p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" id="IconChangeColor" height="18" width="18">
                                    <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" id="mainIconPathAttribute" fill="#FFD700"></path>
                                </svg>
                                <p className="ml-3  text-gray-800 font-medium" style={{ lineHeight: 2 }}>
                                    Copy of the Emirates ID card
                                </p>
                            </div> <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" id="IconChangeColor" height="18" width="18">
                                    <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" id="mainIconPathAttribute" fill="#FFD700"></path>
                                </svg>
                                <p className="ml-3  text-gray-800 font-medium" style={{ lineHeight: 2 }}>
                                    Passport copy of the company director
                                </p>
                            </div> <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" id="IconChangeColor" height="18" width="18">
                                    <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" id="mainIconPathAttribute" fill="#FFD700"></path>
                                </svg>
                                <p className="ml-3  text-gray-800 font-medium" style={{ lineHeight: 2 }}>
                                    Existing business contracts
                                </p>
                            </div> <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" id="IconChangeColor" height="18" width="18">
                                    <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" id="mainIconPathAttribute" fill="#FFD700"></path>
                                </svg>
                                <p className="ml-3  text-gray-800 font-medium" style={{ lineHeight: 2 }}>
                                    Reference letters from business partners
                                </p>
                            </div> <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" id="IconChangeColor" height="18" width="18">
                                    <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" id="mainIconPathAttribute" fill="#FFD700"></path>
                                </svg>
                                <p className="ml-3  text-gray-800 font-medium" style={{ lineHeight: 2 }}>
                                    Documents related to Business plans
                                </p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" id="IconChangeColor" height="18" width="18">
                                    <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" id="mainIconPathAttribute" fill="#FFD700"></path>
                                </svg>
                                <p className="ml-3  text-gray-800 font-medium" style={{ lineHeight: 2 }}>
                                    Certified company incorporation documents
                                </p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" id="IconChangeColor" height="18" width="18">
                                    <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" id="mainIconPathAttribute" fill="#FFD700"></path>
                                </svg>
                                <p className="ml-3  text-gray-800 font-medium" style={{ lineHeight: 2 }}>
                                    Any other document required by the bank
                                </p>
                            </div>
                            <h3 className="text-gray-600 text-3xl font-bold sm:text-3xl pb-1 mt-5">
                                Authentication By The Bank:
                            </h3>
                            <p className="mt-3 text-gray-600">
                                Each document you submit is verified by the bank. Any variance in the document can disapprove your application.
                            </p>
                            <h3 className="text-gray-600 text-2xl font-bold sm:text-1xl pb-1 mt-5" style={{ fontSize: 18 }}>
                                Background and Business Check:
                            </h3>
                            <p className="mt-3 text-gray-600">
                                If the application is approved by the bank, it will conduct a background check of the company and its officials. The bank will scrutinize the management team, the business details, and authenticate the company’s shareholders’ details. This background check can also encompass the financial stability of the company.
                            </p>
                            <h3 className="text-gray-600 text-2xl font-bold sm:text-1xl pb-1 mt-5" style={{ fontSize: 18 }}>
                                Final Interview Is The Last Step:
                            </h3>
                            <p className="mt-3 text-gray-600">
                                If the bank authorities are satisfied, they give further clearance for opening an account. The final step is the interview with the applicant where bank officials can clear their queries; ask them for any other requirements, etc. The process to establish a business bank account is complete.
                            </p>
                        </div>
                    </div>
                </section>
            </div>


            <div className="max-w-screen-xxl mx-auto" style={{ paddingBottom: 40, paddingTop: 40, background: "rgb(242, 249, 255)" }}>
                <section className="py-2 mt-5 ">
                    <div className="max-w-screen-xl mx-auto px-4">
                        <ScrollAnimation animateIn="fadeIn">
                            <h3 className="text-gray-600 text-2xl font-bold sm:text-3xl pb-1 text-center">
                                Our Other <span style={{ color: "#eab308" }}>Services</span>
                            </h3>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="fadeIn">
                        <p className="text-gray-600 mt-2 text-center font-semibold" style={{ fontSize: 18 }}>
                            Also you can find our Other Services here.
                        </p>
                        </ScrollAnimation>
                       
                    </div>
                </section>

                <div className="max-w-screen-xl mx-auto">
                    <div className=" grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
                        {
                            posts.map((items, key) => (
                                <article className="max-w-md mx-auto mt-4 shadow-lg border  rounded-md duration-300 hover:shadow-sm bg-white" key={key} style={{ boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px", borderRadius: 40 }}>
                                    <div className='p-5' >
                                        <a href={items.href}>
                                            <div className="pt-3 ml-4 mr-2 mb-3">
                                                <h3 className="text-gray-600 text-2xl font-bold sm:text-2xl pb-1 " style={{ color: "#eab308" }}>
                                                    {items.title}
                                                </h3>
                                                <p className="text-gray-400 text-sm mt-1 " style={{ fontSize: 14 }}>{items.desc}</p>
                                            </div>
                                        </a>
                                    </div>
                                </article>
                            ))
                        }
                    </div>
                </div>
            </div>


            <div className=''>
                <section className="py-14">
                    <div className="max-w-screen-xl mx-auto md:px-8">
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
                            <div className="flex-1 sm:hidden lg:block" style={{ marginBottom: 200 }}>
                                <div className="fb-iframe-container">
                                    <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fweb.facebook.com%2Fdubaisetupinfo.co&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                                        width="1240" height="500" className='fb-frame' style={{ border: 'none', overflow: 'hidden' }} scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                                </div>
                            </div>
                            <div className="max-w-xl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xl">
                                <div className="fb-container-text">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-4xl mb-5">
                                        Speed Type  <span className="text-yellow-500">Facebook Page</span>
                                    </h3>
                                    <p className="text-gray-900 text-1xl font-normal sm:text-1xl ">
                                        This company's Facebook page is a testament to their dedication to excellence, fostering a vibrant community, and showcasing their creativity. With captivating content and interactive engagement, they go beyond mere promotion, building genuine connections with their audience. Each post tells a story, evoking emotions and leaving a lasting impression on followers. Their commitment to innovation shines through in every aspect of their page, setting them apart from the competition. Moreover, they prioritize customer satisfaction, ensuring transparency and authenticity in all interactions. Their page serves as a window into their values and aspirations, inspiring trust and loyalty among their followers. Overall, this company's Facebook presence embodies their passion for making a difference and leaves a lasting impact on all who engage with it.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


        </>
    )
}
